import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {  Card, Row, Col, Drawer, Button  } from 'antd';
import TestBox from './TestBox';
import {SERVER_PATH, axiosConfig1 } from '../actions/common';
import axios from 'axios';
import { setCbt } from '../actions/cbt';
import { useParams } from 'react-router';

const TestContent = (props) => {
    const {id} = useParams()
    const [answer_pool, setanswer_pool] = useState({})
    const [isloading, setisloading] = useState(false)
    const [cbtquestions, setcbtquestions] = useState([])
    const [questions, setquestions] = useState({})
    const [answers, setanswers] = useState({})
    const [answer, setanswer] = useState({})
    const [starttime, setstarttime] = useState(0)
    const [endtime, setendtime] = useState(0)
    const [duration, setduration] = useState(0)
    const [noq, setnoq] = useState(0)
    const [page, setpage] = useState(1)

    const [visible, setVisible] = useState(false);
    const showDrawer = () => {
      setVisible(true);
    };
    const onClose = () => {
      setVisible(false);
    };
    
    useEffect(() => {
     
      let test_all = props.test_data || {}
      let test = test_all[props.id] || {}
      let cbtquestions = test['cbtquestions'] || {}
      let questions = test['questions'] || {}
      let answers = test['answers'] || {}
      let answer = test['answer'] || {}
      let starttime = test['starttime'] || 0
      let endtime = test['endtime'] || 0
      let duration = test['testtime'] || 0
      let noq = parseInt(test['noq']) || 0
      console.log(props.test_data, test)
     
      setcbtquestions(cbtquestions)
      setquestions(questions)
      setanswers(answers)
      setanswer(answer)
      setnoq(noq)
      setanswer_pool(answer)
      setstarttime(starttime)
      setendtime(endtime)
      setduration(parseInt(duration))
      
    }, [props.id])

   
    var opts = answers[1]
    var ans = answers[0]
   
    
    const setAnswer = (a, b) =>{
        let s = {...answer_pool}
        s[b] = a
        setanswer_pool(s)
    }
    
    const moveForward = (num) =>{
        setpage(e=>e + 1)
    }
    const moveBackward = (num) =>{
        setpage(e=>e - 1)
    }
    const setpages = (num) =>{
        setpage(num)

    }
   
   let num = 0 
   let num1 = 0 
   
  return (
      <>
    {Object
        .keys(questions)
        .map(instruction=>{
           let ques = questions[instruction] 
           return <>
                {ques.map((qid, index1)=>{
                    let q = Object.keys(cbtquestions).filter(rw=>rw == qid)
                    let q1 = cbtquestions[q[0]]
                    let q2 = opts[q[0]]
                    let q3 = answer_pool[q[0]] || ''
                    let g = num++
                    if(typeof q1 == 'object' ){
                     return  <span key={index1} style={{display: page === g ? 'block':'none'}}><Card >
                        <Row gutter={16}>
                        <Col span={24}>
                            <div 
                                style={{whiteSpace:'pre-wraps'}}  
                                dangerouslySetInnerHTML={{__html: instruction}} />
                        </Col>
                    </Row>
                    </Card>
                    <TestBox
                          key={index1}
                          index={g}
                          data={q1}
                          opts={q2}
                          ans={q3}
                          answer={answer_pool[q[0]] || ''}
                          setAnswer={(a)=>setAnswer(a, q[0])}
                          moveForward={(a)=>moveForward(a)}
                          moveBackward={(a)=>moveBackward(a)}
                          showDrawer={showDrawer}
                          submit={()=>props.submit(answer_pool, ans, noq)}
                          pause={()=>props.pause(answer_pool)}
                     /></span>
                    }
                })}
            </>
            
  
  
  
        })}
         <Drawer title="Basic Drawer" placement="right" onClose={onClose} visible={visible}>
        <p>
            {Object
                .keys(questions)
                .map(instruction=>{
                    let ques = questions[instruction] 
                    return <>
                    {ques.map(qid =>{
                        let q = Object.keys(cbtquestions).filter(rw=>rw == qid)
                        let q1 = cbtquestions[q[0]]
                        if(typeof q1 == 'object' ){
                            let n = num1++
                            return <Button 
                            style={{margin:'2px', width:'50px'}}
                            type={answer_pool.hasOwnProperty(qid) ? "primary" : "secondary"} 
                            onClick={()=>setpages(n)}
                            size="small" >{n + 1}</Button>
                        }
                    })
                    }
                    </>
                })
            }
        </p>
    </Drawer>
   </> )

}

const mapStateToProps = (state) => ({
    test_data :state.cbtReducer.cbtTests
  })
  
  const mapDispatchToProps = {setCbt}

export default connect(mapStateToProps, mapDispatchToProps)(TestContent)